import type { WorkspaceFile } from "@/lib/workspace-context";

export function renderMarkdownHTML(text: string = "", files: WorkspaceFile[] = []): string {
  let html = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  html = html.replace(/^### (.*$)/gim, '<h3 class="text-base font-bold text-foreground mt-4 mb-1">$1</h3>');
  html = html.replace(/^## (.*$)/gim, '<h2 class="text-xl font-bold text-foreground border-b border-border/40 pb-1 mt-6 mb-2.5">$1</h2>');
  html = html.replace(/^# (.*$)/gim, '<h1 class="text-2xl font-bold text-foreground mt-8 mb-3.5">$1</h1>');

  html = html.replace(/^\> (.*$)/gim, '<blockquote class="border-l-4 border-primary pl-4 py-1 my-3 bg-secondary/35 rounded-r text-muted-foreground italic">$1</blockquote>');
  html = html.replace(/\`\`\`([\s\S]*?)\`\`\`/gim, '<pre class="bg-secondary/50 border border-border/60 rounded-xl p-4 font-mono text-xs my-4 overflow-x-auto text-foreground/90 whitespace-pre-wrap">$1</pre>');
  html = html.replace(/\`([^\`]+)\`/gim, '<code class="bg-secondary/80 text-primary border border-border/50 px-1.5 py-0.5 rounded font-mono text-xs">$1</code>');
  html = html.replace(/\*\*([^\*]+)\*\*/gim, '<strong class="font-bold text-foreground">$1</strong>');
  html = html.replace(/\*([^\*]+)\*/gim, '<em class="italic">$1</em>');

  html = html.replace(/^\- \[[xX]\] (.*$)/gim, '<div class="flex items-center gap-2 my-1.5"><input type="checkbox" checked disabled class="accent-primary rounded h-3.5 w-3.5 shrink-0" /> <span class="line-through opacity-60 text-foreground/80">$1</span></div>');
  html = html.replace(/^\- \[\s\] (.*$)/gim, '<div class="flex items-center gap-2 my-1.5"><input type="checkbox" disabled class="rounded h-3.5 w-3.5 shrink-0" /> <span class="text-foreground/90">$1</span></div>');

  html = html.replace(/^\- (?!\[[ xX]\])(.*$)/gim, '<li class="list-disc ml-5 my-1 text-foreground/90">$1</li>');
  html = html.replace(/^\* (.*$)/gim, '<li class="list-disc ml-5 my-1 text-foreground/90">$1</li>');
  html = html.replace(/^\d+\. (.*$)/gim, '<li class="list-decimal ml-5 my-1 text-foreground/90">$1</li>');

  const textFiles = files.filter((f) => f.type === "file");
  html = html.replace(/\[\[([^\]]+)\]\]/g, (match, p1) => {
    const cleanLinkName = p1.replace(".md", "").toLowerCase().trim();
    const exists = textFiles.some(
      (f) =>
        f.name.replace(".md", "").toLowerCase().trim() === cleanLinkName ||
        f.name.toLowerCase().trim() === cleanLinkName,
    );

    if (exists) {
      return `<a href="#" class="text-primary hover:underline font-semibold" data-wiki-link="${p1}">[[${p1}]]</a>`;
    }
    return `<a href="#" class="text-destructive/80 border-b border-dashed border-destructive/40 hover:bg-destructive/5 font-semibold" data-wiki-link="${p1}" data-new-link="true">[[${p1}]]?</a>`;
  });

  return html
    .split("\n")
    .map((line) => {
      if (line.trim() === "") return '<div class="h-2"></div>';
      if (
        line.startsWith("<h") ||
        line.startsWith("<li") ||
        line.startsWith("<blockquote") ||
        line.startsWith("<pre") ||
        line.startsWith("<div")
      ) {
        return line;
      }
      return `<p class="my-2 leading-relaxed text-foreground/90">${line}</p>`;
    })
    .join("");
}
